import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
  title: {
    color: theme.palette.primary.main,
    marginTop: theme.spacing(2),
    '& h2': {
      fontWeight: 400,
      fontSize: theme.spacing(4.25),
      lineHeight: `${theme.spacing(6.5)}`
    }
  },
  root: {
    minWidth: theme.spacing(80)
  },
  closeIcon: {
    float: 'right',
    marginTop: '-10px',
    width: '20px',
    height: '20px'
  },
  box: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: theme.spacing(10)
  }
}));
